var projectTimeline = {
	"Project timeline": "Tiến độ dự án",
	"None planned": "Chưa có kế hoạch",
	"1-3 months": "1-3 tháng",
	"4-6 months": "4-6 tháng",
	"7-12 months": "7-12 tháng",
	"More than 1 year": "Hơn 1 Năm"
};

export { projectTimeline as default };
